import { render, staticRenderFns } from "./PorEquipe.vue?vue&type=template&id=1e4c9674&scoped=true"
import script from "./PorEquipe.vue?vue&type=script&lang=js"
export * from "./PorEquipe.vue?vue&type=script&lang=js"
import style0 from "./PorEquipe.vue?vue&type=style&index=0&id=1e4c9674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4c9674",
  null
  
)

export default component.exports